import { Box } from '@mui/material';

import routes from '@/assets/constants/routes-no.ts';
import Page from '@/components/Page/index.ts';
import StaticPageLayout from '@/components/StaticPageLayout/index.ts';

export default function Terms() {
  return (
    <Page title="Påske-trekning vilkår">
      <StaticPageLayout
        title="Vilkår for Scooprs Påsketrekning 2026"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Påsketrekning',
            url: routes.MARCH_2026_COMPETITION,
          },
          {
            text: 'Vilkår for Scooprs Påsketrekning 2026',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 27.02.2026"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h3>1 – Vilkår for Scooprs Påsketrekning 2026</h3>
          <p>
            I mars og begynnelsen av april 2026 avholder Scoopr AS («Scoopr») en trekning om
            innfrielse av rentebærende kredittkortgjeld og forbruksgjeld. Dersom vinnerens samlede
            rentebærende kredittkort- og forbruksgjeld er lavere enn premiebeløpet, kan resterende
            beløp benyttes til nedbetaling av kvalifiserende boliglån, jf. punkt 1.2. Disse
            vilkårene gjelder for deltakelse i trekningen.
          </p>

          <h3>1.1 – Krav for deltakelse</h3>
          <p>
            Trekningen er tilgjengelig for personer over 18 år, som har tilgang til Bank-ID og som
            er bosatt i Norge. Deltakeren må ha en rentebærende forbruks- og/eller kredittkortgjeld
            over 1.000 kr, i tillegg til å søke om lavere rente via Scoopr innenfor tidsperioden til
            kampanjen.
          </p>
          <p>
            Deltakere melder seg på trekningen ved å trykke på «Send søknad og delta» (eller
            tilsvarende formuleringer), godkjenne disse vilkårene, og har gitt samtykke til at
            Scoopr henter ut informasjon fra Gjeldsregisteret.
          </p>
          <p>
            Deltakelse i trekningen bekreftes på e-post etter at søknaden om refinansiering er
            gjennomført.
          </p>
          <p>
            Det er krav om at deltakeren oppretter en «Min Scoopr»- bruker og søker om lavere rente
            via Scoopr. Det koster ingenting å delta i trekningen, og det er ingen krav om å flytte
            gjelden sin for å delta.
          </p>
          <p>
            Vilkårene for Min Scoopr finnes{' '}
            <a href="https://scoopr.no/brukervilkar-min-scoopr" target="_blank" rel="noreferrer">
              her
            </a>
            . Deltakeren kan når som helst avslutte sin brukerkonto etter at trekningen er
            avsluttet.
          </p>
          <p>
            Ansatte i Scoopr og deres ektefeller, samboere, foreldre, søsken eller barn kan ikke
            delta i trekningen. Deltakere som ikke oppfyller kravene, vil bli nektet lodd og/eller
            premie, og utbetalt premie vil bli krevd tilbakebetalt. Scoopr forbeholder seg retten
            til å endre krav for deltakelse, men endringen vil kun ha virkning for deltakere som
            deltar etter endringen er gjort.
          </p>

          <h3>1.2 – Om premien</h3>
          <p>
            Premien til vinneren i trekningen består av innfrielse av deltakerens rentebærende
            kredittkort- og/ eller forbruksgjeld inntil 500.000 kr.
          </p>
          <p>
            Dersom samlet rentebærende kredittkort- og forbruksgjeld på registreringstidspunktet er
            lavere enn 500.000 kr, kan resterende premiebeløp benyttes til ekstraordinær nedbetaling
            av boliglån som oppfyller vilkårene nedenfor. Premien er likevel aldri større enn
            vinnerens rentebærende kredittkort-, forbruks- eller boliggjeld på
            registreringstidspunktet.
          </p>
          <p>Med kvalifiserende boliglån menes lån som:</p>
          <ul className="list-disc pl-6">
            <li>er sikret med pant i helårsbolig (primær- eller sekundærbolig),</li>
            <li>vinner eier helt eller delvis,</li>
            <li>vinner er låntaker eller medlåntaker på, og</li>
            <li>var rentebærende på registreringstidspunktet.</li>
          </ul>
          <p>
            Boliglån som kun står i ektefelles eller samboers navn, lån hvor vinner kun er
            kausjonist, samt lån knyttet til næringsvirksomhet eller næringseiendom, omfattes ikke
            av premien.
          </p>
          <p>
            Beløpet innfris direkte hos banken hvor gjelden er registrert. Innfrielse skjer normalt
            i løpet av en uke etter trekning. Dersom det er registrert usikret gjeld hos flere
            banker, velger Scoopr hvilken bank gjelden innfris hos. Ved bruk av restbeløp til
            boliglån avgjør Scoopr hvilken långiver innfrielsen foretas hos. Det er ikke anledning
            til å få beløpet utbetalt i kontanter, eller i form av andre ytelser.
          </p>

          <h3>1.3 – Vilkår for mottak av premie</h3>
          <p>
            Vinneren kontaktes av Scoopr på telefon og e-post. Vinneren må straks etter å ha blitt
            kontaktet oppgi og bekrefte betalingsopplysninger slik at den aktuelle gjelden kan
            innfris. Dersom dette ikke er gjort innen 5 virkedager, vil retten til premie bortfalle.
          </p>
          <p>
            For usikret kredittkort- og forbruksgjeld legges opplysninger registrert i
            Gjeldsregisteret på registreringstidspunktet til grunn for beregning av premiebeløpet.
            Det er den rentebærende gjelden som fremgår av Gjeldsregisteret på dette tidspunktet som
            anses som kvalifiserende gjeld.
          </p>
          <p>
            Scoopr kan kreve dokumentasjon fra vinner dersom det foreligger avvik mellom
            opplysninger i Gjeldsregisteret og faktisk låneforhold, eller dersom lånet er
            refinansiert, overført eller på annen måte endret etter registreringstidspunktet.
          </p>
          <p>Ved bruk av premie til boliglån plikter vinner å dokumentere:</p>
          <p>Restsaldo per registreringstidspunkt</p>
          <ul className="list-disc pl-6">
            <li>At boliglånet var rentebærende på registreringstidspunktet</li>
            <li>At vinner er låntaker eller medlåntaker</li>
            <li>Eierforhold til boligen</li>
            <li>At boliglånet oppfyller vilkårene i punkt 1.2</li>
          </ul>
          <p>Dokumentasjon kan bestå av:</p>
          <ul className="list-disc pl-6">
            <li>Kontoutskrift som omfatter registreringstidspunktet,</li>
            <li>Låneavtale, eller</li>
            <li>
              Skriftlig bekreftelse fra långiver som viser restsaldo og rente per
              registreringstidspunkt.
            </li>
          </ul>
          <p>
            Scoopr kan, dersom det anses nødvendig, kreve ytterligere dokumentasjon eller
            bekreftelse direkte fra långiver før premie utbetales.
          </p>
          <p>
            Vinnere er selv ansvarlig for å rapportere gevinsten til skattemyndighetene, samt
            overholde andre lovpålagte krav i forbindelse med gevinsten.
          </p>

          <h3>1.4 – Varighet og trekning</h3>
          <p>
            Deltakere som søker om lavere rente via Scoopr i perioden fra 1. mars 2026 til 04. april
            2026 innen kl. 12:00 («Trekningsperioden») er med i trekningen. Det trekkes en vinner
            den 04. april 2026.
          </p>
          <p>
            Vinneren trekkes tilfeldig ved at alle deltakere får tildelt et deltakernummer.
            Trekningen gjøres gjennom tilfeldig trekning ved bruk av «random number generator
            service».
          </p>

          <h3>1.5 – Ansvarlig arrangør og tredjeparter</h3>
          <p>Det er Scoopr som er arrangør av trekningen.</p>
          <p>
            Trekningen støttes eller sponses ikke av noen tredjepart. Det opplyses særskilt om at
            trekningen verken støttes eller sponses av Meta, TikTok, Snapchat eller Google, selv om
            markedsføring skulle foregå gjennom disse kanalene. Deltakere kan ikke rette noen krav
            mot slike tredjeparter i forbindelse med konkurransen.
          </p>

          <h3>1.6 – Deltakerens låneforhold</h3>
          <p>
            Ved refinansiering avslutter deltakeren sitt tidligere låneforhold og erstatter det med
            et nytt. Lånevilkårene, inkludert lånets type, løpetid og renter, kan endres ved en
            refinansiering. Deltakeren er selv ansvarlig for å sette seg inn i de nye lånevilkårene.
          </p>
          <p>
            Scoopr er ikke part i verken det tidligere eller nye låneforholdet og kan derfor ikke
            holdes ansvarlig for verken deltakerens eller låneformidlerens avtalte plikter.
          </p>

          <h3>1.7 – Personopplysninger</h3>
          <p>
            I forbindelse med deltakelse vil Scoopr behandle personopplysninger. Personopplysningene
            benyttes til å registrere «Min Scoopr»-bruker, kontrollere overholdelse av vilkår og
            utnevne og kontakte vinneren.
          </p>
          <p>
            Scoopr behandler også opplysninger fra Gjeldsregisteret. Samtykket kan trekkes tilbake
            når som helst på{' '}
            <a href="https://www.gjeldsregisteret.com/" target="_blank" rel="noreferrer">
              www.gjeldsregisteret.com
            </a>
            .
          </p>
          <p>
            I løpet av Trekningsperioden kan Scoopr sende informasjon på e-post og SMS for å minne
            om trekningen og gi informasjon om trekning og vinnere. Vinnere vil aldri bli annonsert
            med fullt navn, med mindre vinneren har samtykket til dette.
          </p>
          <p>
            Dersom deltakeren har takket ja til å motta markedsføring fra Scoopr, vil det sendes
            markedsføring til vedkommende i etterkant av Trekningsperioden.
          </p>
          <p>
            Opplysningene om deltakere lagres så lenge Trekningsperioden varer og i en viss periode
            etterpå for å kunne påvise at Scoopr har overholdt lovpålagte krav. Opplysningene
            registrert i Min Scoopr oppbevares frem til brukeren sletter sin profil.
          </p>
          <p>
            Opplysningene kan bli delt med andre selskaper i Scoopr-konsernet for formålene
            beskrevet over. Se mer informasjon i Scooprs personvernerklæring{' '}
            <a href="https://scoopr.no/personvernerklaering/" target="_blank" rel="noreferrer">
              her
            </a>
            .
          </p>

          <h3>1.8 – Avbryte</h3>
          <p>
            Dersom uforutsette hendelser skulle oppstå som Scoopr ikke med rimelighet kunne forutse
            ved igangsetting av trekningen, forbeholder Scoopr seg retten til å avbryte konkurransen
            med fremtidig virkning. Scoopr vil likevel tildele premier til vinnere som allerede er
            trukket og så langt mulig varsle deltakere og gi deltakere mulighet til avregistrering
            og avslutning av Min Scoopr-brukeren.
          </p>

          <h3>1.9 – Henvendelser</h3>
          <p>
            Dersom deltakeren har spørsmål om disse vilkårene eller andre forhold kan Scoopr AS, med
            adresse Karenslyst Allé 2, 0278 Oslo, kontaktes på telefon{' '}
            <a href="tel:41800000">418 00 000</a> eller på e-post til{' '}
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>.
          </p>

          <br />
          <h4>Scoopr AS</h4>
          <h4>Scoopr Refinansiering AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
